import UserRoleList from "./pages/ListPage.vue";
import UserRoleDetail from "./pages/FormPage.vue";
import UserRoleIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/user_role",
    component: UserRoleIndex,
    redirect: "/user_role/list",
    name: "user_role",
    children: [
      {
        path: "list",
        component: UserRoleList,
        name: "user_role.list",
      },
      {
        path: "create",
        component: UserRoleDetail,
        name: "user_role.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: UserRoleDetail,
        name: "user_role.edit",
        props: { create: false },
      },
    ],
  },
];
